module.exports = __webpack_public_path__ + "media/images/photo/plans/common/img_chapel-photo-f999f22110cf715edf74a966157cae30.jpg";